import {InputNumber, Space} from 'antd';
import Card from '../../../../Card';
import styled from 'styled-components';
import {typographyStyles} from '../../../../../utils/styles';

const StyledCompanyInfo = styled(Card)`
  border-top-left-radius: 0;
  .ant-card-head {
    flex-direction: unset;
    padding: 24px;
  }

  .company-info-details {
    padding: 0;
  }

  .title-error-message {
    color: ${props => props.theme.colors.functional_danger} !important;
    display: block;
    font-size: 14px;
    font-weight: 400;
    margin-top: 8px;
  }
`;

const StyledCompanyInfoSpace = styled(Space)`
  min-height: 32px;
  .ant-space-item {
    display: flex;
  }
   h3 {
     ${typographyStyles.heading.h5};
     margin-bottom: 0;
     svg {
       height: 20px;
       width: 20px;
       path {
         stroke: ${props => props.theme.colors.neutral_10};
       }
     }
  }
`;

const StyledCompanyInfoAmountInput = styled(InputNumber)`
  width: 100%;
  height: 38px;

  &.ant-input-number-group-wrapper-status-error {
    .ant-input-number-group-addon {
      &:first-child {
        border-color: ${props => props.theme.colors.functional_danger};
      }
    }
  }

  .ant-input-number-group-addon {
    background-color: transparent;
    svg {
      width: 16px;

      path {
        fill: ${props => props.theme.colors.neutral_6};
      }
    }
  }
`;

const StyledCompanyInfoHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const StyledCompanyInfoTitle = styled.div`
  align-items: start;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export {
  StyledCompanyInfo,
  StyledCompanyInfoAmountInput,
  StyledCompanyInfoHeader,
  StyledCompanyInfoTitle,
  StyledCompanyInfoSpace
}
